import { Component } from '@angular/core';
import { IonAccordion, IonAccordionGroup, IonItem, IonLabel } from '@ionic/angular/standalone';

@Component({
  selector: 'lib-fastpay-info-conditions',
  templateUrl: './fastpay-info-conditions.component.html',
  styleUrls: ['./fastpay-info-conditions.component.scss'],
  imports: [IonAccordionGroup, IonLabel, IonAccordion, IonItem],
})
export class FastpayInfoConditionsComponent {
  // constructor() {}
}
